import shipmentCarrierSummary from '@src/shipment-carrier-summary/menu';
import emonsSummary from '@src/emons/menu';
import packaging from '@src/packaging/menu';
import shipmentCarrier from '@src/shipment-carrier-settings/menu';
import { MenuEntry } from '@src/menu-entry';

export default MenuEntry.create()
    .setTitle('Versand')
    .setChildren([
        MenuEntry.create()
            .setTitle('Versenden')
            .setRoute('ship-out_create'),
        MenuEntry.create()
            .setRoute('ship-out_list-shipments')
            .setAdditionalRoutes([
                'ship-out_shipment-detail',
            ]),
        MenuEntry.create()
            .setRoute('shipment_type_list')
            .setAdditionalRoutes([
                'shipment_type_detail',
            ]),
        MenuEntry.create()
            .setRoute('ship-out_manually'),
        MenuEntry.create()
            .setRoute('manual_shipment_queue-list')
            .setAdditionalRoutes([
                'manual_shipment_queue-detail',
            ]),
        MenuEntry.create()
            .setRoute('manual_shipment_queue-finish'),
        MenuEntry.create()
            .setTitle('Tagesabschluss')
            .setChildren([
                shipmentCarrierSummary,
                emonsSummary,
            ]),
        MenuEntry.create()
            .setRoute('ship-out_docs'),
        packaging,
        shipmentCarrier,
    ]);
